<template>
  <!--角色管理 -->
  <div class="newsPage">
    <div>
      <el-card style="margin: 30px">
        <div style="display: flex;align-items: center">
          <div>活动名称：</div>
          <el-input clearable placeholder="请输入活动名称" size="small" style="width: 180px;margin-right: 10px"
                    v-model="voteName"></el-input>
          <el-button size="small" type="primary" @click="searchBtn">查询</el-button>
          <el-button size="small" type="danger" @click="resetBtn">重置</el-button>
          <el-button size="small" type="success" @click="addBtn">新增</el-button>
        </div>

        <el-table
            size="small"
            tooltip-effect="dark"
            ref="multipleTable"
            :data="tableData"
            border
            style="width: 100%;margin-top: 30px"
        >
          <el-table-column
              align="center"
              label="活动名称"
              prop="vote_name"
          />
          <el-table-column
              align="center"
              label="栏目一"
              prop="one_name"
          />
          <el-table-column
              align="center"
              label="栏目二"
              prop="two_name"
          />
          <el-table-column
              align="center"
              label="栏目三"
              prop="three_name"
          />
          <el-table-column
              align="center"
              label="开始时间"
              prop="start_date"
              width="150"
          />
          <el-table-column
              align="center"
              label="结束时间"
              prop="end_date"
              width="150"
          />
          <el-table-column
              align="center"
              label="按钮文本"
              prop="button_text"
          />
          <el-table-column
              align="center"
              label="单位名称"
              prop="unit"
          />
          <el-table-column
              align="center"
              label="活动允许投票数"
              prop="vote_count"
          />
          <el-table-column
              align="center"
              label="操作"
              width="320"
          >
            <template slot-scope="scope">
              <el-button style="margin-top: 10px"
                         class="btns"
                         :data-clipboard-text="'http://8.140.150.245:8082/jcxbLike?id=' + scope.row.id" @click="copyBtn(scope.row)" size="small" type="primary">复制链接
              </el-button>
              <el-button style="margin-top: 10px" @click="viewBtn(scope.row)" size="small" type="primary">活动明细
              </el-button>
              <el-button @click="editBtn(scope.row)"
                         size="small"
                         type="success">修改
              </el-button>
              <el-button @click="detailsBtn(scope.row)"
                         size="small"
                         type="success">详情
              </el-button>
              <el-button style="margin-top: 10px" @click="deleteBtn(scope.row)" size="small" type="danger">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="display: flex;justify-content: center;margin-top: 20px"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[20, 30, 40, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements">
        </el-pagination>
      </el-card>
    </div>

    <el-dialog
        :modal-append-to-body='false'
        :visible="addDialogState"
        :title="dialogTitle"
        width="1000px"
        @close="addCancel"
    >
      <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="上背景图" prop="backgroundUrl">
              <el-upload
                  :disabled="dialogTitle === '详情'"
                  :before-upload="topUrlBeforeAvatarUpload"
                  :on-success="topUrlHandleAvatarSuccess"
                  :show-file-list="false"
                  :action="uploadApiUrl"
                  class="coverClass cover-uploader">
                <img v-if="ruleForm.backgroundUrl" :src="ruleForm.backgroundUrl" class="cover">
                <i v-else class="el-icon-plus cover-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="下背景图" prop="backgroundBottomUrl">
              <el-upload
                  :disabled="dialogTitle === '详情'"
                  :before-upload="bottomUrlBeforeAvatarUpload"
                  :on-success="bottomUrlHandleAvatarSuccess"
                  :show-file-list="false"
                  :action="uploadApiUrl"
                  class="topcoverClass cover-uploader">
                <img v-if="ruleForm.backgroundBottomUrl" :src="ruleForm.backgroundBottomUrl" class="cover">
                <i v-else class="el-icon-plus cover-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="活动名称" prop="voteName">
              <el-input :readonly="dialogTitle === '详情'" v-model="ruleForm.voteName" style="width: 100%" size="small" placeholder="请输入活动名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="活动类型" prop="voteType">
              <el-select :disabled="dialogTitle === '详情'" v-model="ruleForm.voteType" placeholder="请选择" size="small" style="width: 100%">
                <el-option
                    v-for="item in [{'key':'1','value':'图片'},{'key':'2','value':'视频'}]"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="下背景色" prop="backgroundColor">
                <el-color-picker style="z-index: 9999" :disabled="dialogTitle === '详情'" v-model="ruleForm.backgroundColor"></el-color-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="按钮颜色" prop="buttonColor">
              <el-color-picker :disabled="dialogTitle === '详情'" v-model="ruleForm.buttonColor"></el-color-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="栏目一" prop="oneName">
              <el-input :readonly="dialogTitle === '详情'" v-model="ruleForm.oneName" style="width: 100%" size="small" placeholder="请输入栏目一名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="栏目二" prop="twoName">
              <el-input :readonly="dialogTitle === '详情'" v-model="ruleForm.twoName" style="width: 100%" size="small" placeholder="请输入栏目二名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="栏目三" prop="threeName">
              <el-input :readonly="dialogTitle === '详情'" v-model="ruleForm.threeName" style="width: 100%" size="small" placeholder="请输入栏目三名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="起止时间" prop="value">
              <el-date-picker
                  :disabled="dialogTitle === '详情'"
                  size="small"
                  v-model="ruleForm.value"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="按钮文本" prop="buttonText">
              <el-input :readonly="dialogTitle === '详情'" v-model="ruleForm.buttonText" style="width: 100%" size="small" placeholder="请输入按钮文本"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="单位名称" prop="unit">
              <el-input :readonly="dialogTitle === '详情'" v-model="ruleForm.unit" style="width: 100%" size="small" placeholder="请输入单位名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="允许投票数" prop="voteCount">
              <el-input-number
                  :disabled="dialogTitle === '详情'"
                  v-model="ruleForm.voteCount"
                  :step="1"
                  :min="0"
                  size="small"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="活动说明" prop="voteRule">
              <el-input :readonly="dialogTitle === '详情'" type="textarea" v-model="ruleForm.voteRule" style="width: 100%" size="small"
                        placeholder="请输入活动说明(多条请用｜符号隔开)"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addCancel">取 消</el-button>
        <el-button type="primary" @click="addSubmit('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>

    <!--    删除的弹窗-->
    <a-modal
        title="提示"
        :visible="deleteDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="deleteCancel"
        @ok="deleteSubmit"
    >
      <div>{{ simpleDelete ? '是否删除该条记录？' : '是否删除当前所选中的记录？' }}</div>
    </a-modal>
  </div>
</template>
<script>
import {baseURL} from "@/api/config";
import moment from "moment";
import Clipboard from "clipboard";

export default {
  data() {
    return {
      dialogTitle: '',
      pageNum: 1,
      pageSize: 20,
      examineStatus: null,
      menu: null,
      voteName: '',
      tableData: [],
      totalElements: 0,//数据总数
      addDialogState: false,
      ruleForm: {
        id: null,
        backgroundUrl: '',
        backgroundBottomUrl: '',
        voteName: '',
        backgroundColor: '',
        oneName: '',
        twoName: '',
        threeName: '',
        startDate: '',
        endDate: '',
        value: '',
        voteRule: '',
        buttonColor: '',
        buttonText: '',
        unit: '',
        voteCount: 0,
        voteType: null
      },
      rules: {
        backgroundUrl: [{required: true, message: "请上传上背景图", trigger: "blur"}],
        backgroundBottomUrl: [{required: true, message: "请上传下背景图", trigger: "blur"}],
        voteName: [{required: true, message: "请输入活动名称", trigger: "blur"}],
        backgroundColor: [{required: true, message: "请输入背景图背景色", trigger: "blur"}],
        oneName: [{required: true, message: "请输入栏目一名称", trigger: "blur"}],
        value: [{required: true, message: "请选择起止时间", trigger: "blur"}],
        twoName: [{required: true, message: "请输入栏目二名称", trigger: "blur"}],
        threeName: [{required: true, message: "请输入栏目三名称", trigger: "blur"}],
        voteRule: [{required: true, message: "请输入活动说明", trigger: "blur"}],
        buttonColor: [{required: true, message: "请输入按钮背景", trigger: "blur"}],
        buttonText: [{required: true, message: "请输入按钮文本", trigger: "blur"}],
        unit: [{required: true, message: "请输入单位名称", trigger: "blur"}],
        voteCount: [{required: true, message: "请输入允许投票数", trigger: "blur"}],
        voteType: [{required: true, message: "请选择活动类型", trigger: "blur"}],
      },
      uploadApiUrl: '',
      simpleDelete: false,
      deleteId: null,
      deleteDialogState: false,
      multipleSelection: [],
      currentId: null,
      currentMenu: null,
      newsIsHave: [],
      newsAllHave: [],
      dialogvoteName: '',
      dialogPage: 1,
      dialogSize: 5,
      dialogTotal: 0,
    };
  },
  mounted() {

  },
  methods: {
    searchBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.getNewsList()
    },
    resetBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.examineStatus = null
      this.menu = null
      this.voteName = ''
      this.getNewsList()
    },
    addBtn() {
      this.dialogTitle = '新增'
      this.ruleForm = {
        id: null,
        backgroundUrl: '',
        backgroundBottomUrl: '',
        voteName: '',
        backgroundColor: '',
        oneName: '',
        twoName: '',
        threeName: '',
        startDate: '',
        endDate: '',
        value: '',
        voteRule: '',
        buttonColor: '',
        buttonText: '',
        unit: '',
        voteCount: 0,
        voteType: null
      }
      this.addDialogState = true
    },
    editBtn(row) {
      this.dialogTitle = '修改'
      this.ruleForm.id = row.id
      this.ruleForm.backgroundUrl = row.background_url
      this.ruleForm.backgroundBottomUrl = row.background_bottom_url
      this.ruleForm.voteName = row.vote_name
      this.ruleForm.voteType = row.vote_type
      this.ruleForm.backgroundColor = row.background_color
      this.ruleForm.buttonColor = row.button_color
      this.ruleForm.oneName = row.one_name
      this.ruleForm.twoName = row.two_name
      this.ruleForm.threeName = row.three_name
      this.ruleForm.value = [row.start_date, row.end_date]
      this.ruleForm.buttonText = row.button_text
      this.ruleForm.unit = row.unit
      this.ruleForm.voteCount = row.vote_count
      this.ruleForm.voteRule = row.vote_rule
      this.addDialogState = true
    },
    detailsBtn(row){
      this.dialogTitle = '详情'
      this.ruleForm.id = row.id
      this.ruleForm.backgroundUrl = row.background_url
      this.ruleForm.backgroundBottomUrl = row.background_bottom_url
      this.ruleForm.voteName = row.vote_name
      this.ruleForm.voteType = row.vote_type
      this.ruleForm.backgroundColor = row.background_color
      this.ruleForm.buttonColor = row.button_color
      this.ruleForm.oneName = row.one_name
      this.ruleForm.twoName = row.two_name
      this.ruleForm.threeName = row.three_name
      this.ruleForm.value = [row.start_date, row.end_date]
      this.ruleForm.buttonText = row.button_text
      this.ruleForm.unit = row.unit
      this.ruleForm.voteCount = row.vote_count
      this.ruleForm.voteRule = row.vote_rule
      this.addDialogState = true
    },
    viewBtn(row) {
      this.$router.push({
        path: "/voteDetailsList", query: {
          id: row.id
        }
      });
    },
    copyBtn(row){
      var that = this;
      var clipboard = new Clipboard(".btns"); //单页面引用
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        this.$message.error("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    deleteBtn(row) {
      this.simpleDelete = true
      this.deleteId = row.id
      this.deleteDialogState = true
    },
    batchDeleteBtn() {
      this.simpleDelete = false
      this.deleteDialogState = true
    },
    deleteCancel() {
      this.deleteDialogState = false
    },
    deleteSubmit() {
      if (this.simpleDelete) {
        //单个删除
        this.postAxios("/handVote/delHandVoteById?id=" + this.deleteId).then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.deleteId = ''
            this.deleteDialogState = false
            this.resetBtn()
          }
        })
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    addCancel() {
      this.addDialogState = false
      this.$refs.ruleForm.clearValidate();
    },
    addSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogTitle === '新增') {
            this.ruleForm.startDate = moment(this.ruleForm.value[0]).format('YYYY-MM-DD HH:mm:ss')
            this.ruleForm.endDate = moment(this.ruleForm.value[1]).format('YYYY-MM-DD HH:mm:ss')
            this.postAxios("/handVote/addHandVote", this.ruleForm).then(res => {
              if (res.success) {
                this.$message.success("添加成功!")
                this.addDialogState = false
                this.getNewsList()
              }
            });
          }else if(this.dialogTitle === '修改'){
            this.ruleForm.startDate = moment(this.ruleForm.value[0]).format('YYYY-MM-DD HH:mm:ss')
            this.ruleForm.endDate = moment(this.ruleForm.value[1]).format('YYYY-MM-DD HH:mm:ss')
            this.postAxios("/handVote/updHandVoteById", this.ruleForm).then(res => {
              if (res.success) {
                this.$message.success("修改成功!")
                this.addDialogState = false
                this.getNewsList()
              }
            });
          }
        }
      });
    },
    topUrlHandleAvatarSuccess(res) {
      if (res.success) {
        this.ruleForm.backgroundUrl = res.entity;
      }
    },
    topUrlBeforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    bottomUrlHandleAvatarSuccess(res) {
      if (res.success) {
        this.ruleForm.backgroundBottomUrl = res.entity;
      }
    },
    bottomUrlBeforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    getNewsList() {
      let url = '/handVote/selHandVote'
      this.postAxios(url, {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        parameterMap: {
          voteName: this.voteName,
        }
      }).then(res => {
        if (res.success) {
          this.tableData = []
          this.tableData = res.content;
          this.totalElements = res.totalCount
        } else {
          this.tableData = []
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getNewsList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getNewsList()
    },
  },
  created() {
    this.uploadApiUrl = baseURL + '/file/uploadFile/v2'
    this.getNewsList();
  }
};
</script>
<style lang="less" scoped>

.coverClass {
  .cover-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .cover-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .cover-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    border: 1px dashed #d9d9d9;
    width: 314px;
    height: 190px;
    line-height: 190px;
    text-align: center;
  }

  .cover {
    width: 314px;
    height: 190px;
    display: block;
  }
}

.topcoverClass {
  .cover-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .cover-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .cover-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    border: 1px dashed #d9d9d9;
    width: 120px;
    height: 190px;
    line-height: 190px;
    text-align: center;
  }

  .cover {
    width: 120px;
    height: 190px;
    display: block;
  }
}

</style>
